const presetKey = (renderModelKey, renderLayoutKey) => `${renderModelKey || ''}|${renderLayoutKey || ''}`;
export {
  presetKey
};
